import { useCallback, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import ActivityAttendanceField, {
  AssistanceRequirementValues,
} from './ActivityAttendanceField';

type ActivityAttendanceFieldsTableProps = {
  supportsOnline?: boolean;
  onlineAssistanceMinPercentage?: number;
  assistanceRequirements: Record<string, AssistanceRequirementValues>;
  setAssistanceRequirements: (item: object) => void;
  onChangeOnlineAssistanceMinPercentage?: (value: number) => void;
};

const ActivityAttendanceFieldsTable = ({
  assistanceRequirements,
  supportsOnline = false,
  setAssistanceRequirements,
}: ActivityAttendanceFieldsTableProps) => {
  const { control } = useFormContext<{
    onlineAssistanceRequirement: number;
  }>();

  const assistanceRequirementsItems = useMemo(
    () =>
      Object.values(assistanceRequirements || {}).sort(
        (a, b) => a.activityTypeId - b.activityTypeId,
      ),
    [assistanceRequirements],
  );

  const handleChangeAssistanceRequirement = useCallback(
    (updatedItem: AssistanceRequirementValues) => {
      setAssistanceRequirements({
        ...assistanceRequirements,
        [updatedItem.id]: updatedItem,
      });
    },
    [assistanceRequirements, setAssistanceRequirements],
  );

  return (
    <div className="activity-table text-center">
      <div
        className="w-full d-flex flex-wrap align-items-center mb-5"
        style={{ gap: 5 }}
      >
        {assistanceRequirementsItems.map((item, i) => (
          <ActivityAttendanceField
            key={String(i)}
            item={item}
            onChangeItem={handleChangeAssistanceRequirement}
          />
        ))}
        {!!supportsOnline && (
          <Controller
            control={control}
            name="onlineAssistanceRequirement"
            render={({ field }) => (
              <ActivityAttendanceField
                item={{
                  id: -1,
                  name: 'Online',
                  minPercentage: field.value ?? 0,
                  activityTypeId: -1,
                }}
                onChangeItem={(next) => field.onChange(next.minPercentage)}
              />
            )}
          />
        )}
      </div>
    </div>
  );
};

export default ActivityAttendanceFieldsTable;
